export default __webpack_public_path__ + "static/media/play-black.3d8a856e.svg";